import React, { useRef } from "react"
import { AntdButton } from "components"
import { FieldError, FieldValues, Path, UseFormSetError } from "react-hook-form"
import { UploadOutlined } from "@ant-design/icons"
import { FILE_SIZE_LIMIT_CONSTANTS } from "../config/constants"

interface Props<T extends FieldValues> {
	onDocumentChange(file: File): void
	errors?: { [key: string]: FieldError | undefined }
	name: keyof T
	loading?: boolean
	documentName?: string
	containerClass?: string
	setError?: UseFormSetError<T>
	clearErrors?: (name?: any) => void
}

const DocumentField = <T extends FieldValues>({
	documentName = "",
	onDocumentChange,
	name = "",
	loading = false,
	containerClass = "",
	setError,
	clearErrors,
}: Props<T>) => {
	const inputRef = useRef<HTMLInputElement>(null)

	return (
		<div>
			<div className={`flex flex-row ${containerClass}`}>
				<input
					ref={inputRef}
					type="file"
					className="hidden"
					name="link"
					onChange={e => {
						if (e.target.files && e.target.files.length > 0) {
							const file = e.target.files[0]
							const fileSizeInMB = file.size / (1024 * 1024)

							if (fileSizeInMB > FILE_SIZE_LIMIT_CONSTANTS.FILE_SIZE_LIMIT) {
								setError?.(name as Path<T>, {
									type: "manual",
									message: FILE_SIZE_LIMIT_CONSTANTS.FILE_SIZE_LIMIT_ERROR_MESSAGE,
								})
								e.target.value = ""
								return
							}

							clearErrors?.(name)
							const reader = new FileReader()
							reader.onload = (): void => {
								if (e.target.files?.length) {
									onDocumentChange(e.target.files[0])
									e.target.value = ""
								}
							}
							reader.readAsDataURL(e.target.files[0])
						}
					}}
				/>

				<AntdButton
					disabled={loading}
					name="link"
					icon={<UploadOutlined />}
					onClick={e => {
						e.preventDefault()
						if (inputRef && inputRef.current) {
							inputRef?.current?.click()
						}
					}}
				>
					{documentName ? documentName.slice(0, 15) + "..." : "Add Document"}
				</AntdButton>
			</div>
			<p className="ml-2 w-40.75 self-center overflow-hidden text-ellipsis whitespace-nowrap">{documentName}</p>
		</div>
	)
}

export default DocumentField
